export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || '';

const API_PREFIX = process.env.REACT_APP_API_PREFIX || '';

export const BASE_UAPI_URL = BASE_API_URL + API_PREFIX;
